import React from 'react';
import PropTypes from 'prop-types';
import Overflow from './ui/Overflow';

class DashboardProducts extends React.Component{

    renderFavorites = (user, productTitle) => {
        if(user._NKFavouriteItems && user._NKFavouriteItems.includes(productTitle)) {
            return <i className="material-icons favorite">favorite</i>;
        }
        return <i className="material-icons favorite-border">favorite_border</i>;
    };

    getAccess = (user, product) => {
        let access = false;

        if(user.tags){
            if(product && product.tagsForAccess){
                const tagsForAccess = product.tagsForAccess.split(',');
                tagsForAccess.forEach(tag => {
                    if(user.tags.includes(tag)){
                        access = true;
                    }
                });
            }

            if(product && product.tagsForDenyAccess){
                const tagsForDenyAccess = product.tagsForDenyAccess.split(',');
                tagsForDenyAccess.forEach(tag => {
                    if(user.tags.includes(tag)){
                        access = false;
                    }
                });
            }
        }

        return access ? 'hasAccess' : 'noAccess';
    };

    render() {
        const user = this.props.user;
        return (
            <div className="tab-panel products">
                <input className="input-search" type="text" defaultValue={this.props.userProductSearch} onChange={e => this.props.filterProducts(e, 'userProductSearch')} placeholder="Search products"/>
                <table className="table productTable">
                    <thead>
                        <tr>
                            <th className="iconCell"></th>
                            <th className="titleCell">Title</th>
                            <th className="categoryCell">Categories</th>
                            <th className="tagCell">Access tags</th>
                            <th className="statusCell">Started</th>
                            <th className="statusCell">Complete</th>
                            <th className="iconCell"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            Object.keys(this.props.products).map(productKey => {
                                const product = this.props.products[productKey];
                                let productStarted = false;
                                let productComplete = false;

                                if(this.props.user && this.props.user.tags){
                                    const tags = this.props.user.tags;
                                    productStarted = product.courseStartedTag && tags.indexOf(product.courseStartedTag) >= 0;
                                    productComplete = product.courseCompleteTag && tags.indexOf(product.courseCompleteTag) >= 0;
                                }

                                if(product) {
                                    return (
                                        <tr key={productKey} className={this.getAccess(user, product)}>
                                            <td className="productOfTheMonth iconCell">{this.renderFavorites(user, product.title)}</td>
                                            <td className="productTitle titleCell">{product.title}</td>
                                            <td className="categoryCell">
                                                {product.circleContent === "true" ? <img alt="Circle content" src="images/circle-icon.svg"/> : null}
                                                {product.midasRecovery === "true" ? <img alt="Midas recovery" src="images/midasRecovery-icon.svg"/> : null}
                                                {product.violetFlame === "true" ? <img alt="Violet flame" src="images/violetFlame-icon.svg"/> : null}
                                                {product.gettingStarted === "true" ? <img alt="Getting started" src="images/gettingStarted-icon.svg"/> : null}
                                                {product.deepDiveCourse === "true" ? <img alt="Deep dive" src="images/deepDive-icon.svg"/> : null}
                                            </td>
                                            <td className="tagCell">{this.props.renderTags(product.tagsForAccess, product.tagsForDenyAccess)}</td>
                                            <td className="statusCell"><i className={productStarted ? 'material-icons green' : 'material-icons red'}>{productStarted ? 'check_circle' : 'cancel'}</i></td>
                                            <td className="statusCell"><i className={productComplete ? 'material-icons green' : 'material-icons red'}>{productComplete ? 'check_circle' : 'cancel'}</i></td>
                                            <td className="iconCell">
                                                <Overflow
                                                    options={[  {label: "Grant access", icon: "add_circle", action: this.props.addTags},
                                                                {label: "Revoke access", icon: "remove_circle", action: this.props.removeTags}
                                                            ]}
                                                    argument={productKey}
                                                />
                                            </td>
                                        </tr>
                                    );
                                }
                                else {
                                    return null;
                                }
                            })
                        }
                    </tbody>
                </table>
            </div>
        );
    }
}

DashboardProducts.propTypes = {
    userProductSearch: PropTypes.string.isRequired,
    user: PropTypes.object.isRequired,
    products: PropTypes.object.isRequired,
    renderTags: PropTypes.func.isRequired,
    addTags: PropTypes.func.isRequired,
    removeTags: PropTypes.func.isRequired,
    filterProducts: PropTypes.func.isRequired
}

export default DashboardProducts;


/** WEBPACK FOOTER **
 ** ./src/components/DashboardProducts.js
 **/